import { Component } from '@angular/core';
import { ModalService } from 'src/core/services/modal.service';

@Component({
  selector: 'app-image-preview',
  imports: [],
  templateUrl: './image-preview.component.html',
  styleUrl: './image-preview.component.css',
})
export class ImagePreviewComponent {
  imageSrc: any;
  
  constructor(private modalService: ModalService) { 
    
  }

  ngOnInit() {
    this.modalService.$modalChanged.subscribe((modal) => {
      if (modal && modal.modal === 'image-preview' && modal.open === true) {
        this.imageSrc = modal.filter[0].value;
      }
    });
  }

  
}
